import {InjectionToken} from '@angular/core'
import {PromotionalPacksEmbeddedService} from '../shared/promotional-packs/services/promotional-packs.embedded.service'
import {PromotionalPacksService} from '../shared/promotional-packs/services/promotional-packs.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `PromotionalPacksService`.
 *
 * @description
 * Devuelve `PromotionalPacksEmbeddedService` en modo embebido y
 * `PromotionalPacksService` en modo standalone. El servicio modela los
 * packs promocionales (combos de productos con descuentos) disponibles
 * en el flujo de alta/edición de pedidos y actúa como adaptador para
 * `PROMOTIONAL_PACKS_SERVICE_ADAPTER`.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `PromotionalPacksService`.
 */
export function providerPacksServiceFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new PromotionalPacksEmbeddedService()
  }
  return new PromotionalPacksService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `PromotionalPacksService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerPacksServiceFactory}.
 */
export const PacksServiceToken = new InjectionToken<PromotionalPacksService>('PacksService')
